export default "/assets/images/technology-graph-03.svg?f34b7d8983cbeaf930c7bfe22bcaac9b";